import React from "react";
import { MapPin, Phone, Clock } from "lucide-react";
import { clinic, hours } from "../data";

export default function MapSection() {
  // Малый Московский переулок, 1 — координаты самой клиники по OpenStreetMap.
  // Прежние (57.6224, 39.8865) указывали на Богоявленскую площадь в 1,2 км
  // отсюда; пока карта искала организацию по названию, этого не было видно.
  const lat = 57.61170;
  const lng = 39.88049;
  // Без параметра text= виджет не ищет организацию и не открывает её
  // карточку — остаётся чистая карта с меткой из pt=
  const yandexEmbed = `https://yandex.ru/map-widget/v1/?ll=${lng}%2C${lat}&z=17&l=map&pt=${lng}%2C${lat}%2Cpm2rdm`;

  return (
    <section className="map-section" id="map" data-testid="map-section">
      <div className="container">
        <div className="section-label">Как нас найти</div>
        <h2 className="section-title">Мы в центре Ярославля</h2>
        <p className="section-subtitle">
          Удобное расположение в центре города. Парковка для пациентов и пешеходный доступ от ключевых улиц.
        </p>

        <div className="map-wrap">
          {/* Поверх карты лежит прозрачный слой (.map-frame::after), который
              не пропускает нажатия: из виджета можно уйти на Яндекс Карты,
              где у клиники свой телефон и запись — мимо отслеживания.
              Логотип и условия Яндекса остаются видны, как того требуют
              их правила, но кликнуть по ним нельзя. Заодно карта больше не
              перехватывает прокрутку страницы на телефоне. */}
          <div className="map-frame">
            <iframe
              src={yandexEmbed}
              title="Карта проезда"
              loading="lazy"
              tabIndex={-1}
              aria-hidden="true"
            />
          </div>

          <div className="map-info">
            <div className="map-info-item">
              <div className="mi-icon"><MapPin size={20} /></div>
              <div>
                <div className="mi-title">Адрес</div>
                <div className="mi-text">{clinic.address}, {clinic.city}</div>
              </div>
            </div>

            <div className="map-info-item">
              <div className="mi-icon"><Clock size={20} /></div>
              <div>
                <div className="mi-title">Часы работы</div>
                {hours.map((h) => (
                  <div key={h.days} className="mi-text">{h.days}: {h.time}</div>
                ))}
              </div>
            </div>

            <div className="map-info-item">
              <div className="mi-icon"><Phone size={20} /></div>
              <div>
                <div className="mi-title">Телефон</div>
                <a href={`tel:${clinic.phoneRaw}`} className="mi-text mi-link">{clinic.phone}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
